module.exports = __webpack_public_path__ + "img/hubspot.c35193e2.svg";